// Public
export const HOME_PAGE_URL = '/';
export const CONTACT_PAGE_URL = '/contact';
export const POLICIES_PAGE_URL = '/user-agreements';
export const MAINTENANCE_PAGE_URL = '/down-for-maintenance';
export const ERROR_404_PAGE_URL = '*';

// User
export const VERIFY_EMAIL_PAGE_URL = '/verify-email-address/:userId/:uniqueString';
export const FORGOT_PASS_PAGE_URL = '/forgot-password';
export const RESET_PASS_PAGE_URL = '/reset-password/:userId/:token';

// Admin
export const ADMIN_PAGE_URL = '/admin';